import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export interface PersonalInfoFormData {
  fullName: string;
  description: string;
  photoUrl: string;
  resumeUrl: string;
  isResumePublic: boolean;
  forSelf: boolean;
  createdAt?: number;
  updatedAt?: number;
}

interface PersonalInfoFormProps {
  formData: PersonalInfoFormData;
  onChange: (data: PersonalInfoFormData) => void;
  onSubmit: (e: React.FormEvent) => void;
  submitLabel?: string;
}

export function PersonalInfoForm({
  formData,
  onChange,
  onSubmit,
  submitLabel = 'حفظ',
}: PersonalInfoFormProps) {
  const handleChange = (field: keyof PersonalInfoFormData, value: any) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="fullName">الاسم الرباعي</Label>
        <Input
          id="fullName"
          required
          value={formData.fullName}
          onChange={(e) => handleChange('fullName', e.target.value)}
          placeholder="أدخل الاسم الرباعي"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">نبذة مختصرة</Label>
        <Textarea
          id="description"
          required
          value={formData.description}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="اكتب نبذة مختصرة"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="photoUrl">رابط الصورة الشخصية (اختياري)</Label>
        <Input
          id="photoUrl"
          type="url"
          value={formData.photoUrl}
          onChange={(e) => handleChange('photoUrl', e.target.value)}
          placeholder="https://..."
          dir="ltr"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="resumeUrl">رابط السيرة الذاتية PDF (اختياري)</Label>
        <Input
          id="resumeUrl"
          type="url"
          value={formData.resumeUrl}
          onChange={(e) => handleChange('resumeUrl', e.target.value)}
          placeholder="https://..."
          dir="ltr"
        />
      </div>

      <Button
        type="submit"
        className="w-full hover:bg-secondary"
        disabled={!formData.fullName || !formData.description}
      >
        {submitLabel}
      </Button>
    </form>
  );
}